import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeDropper = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 7.50006L16 4.00006C17.1046 2.89549 18.8954 2.89549 20 4.00006C21.1046 5.10463 21.1046 6.89549 20 8.00006L16.5 11.5001M11 6.00006L18 13.0001M14 14.0001L10.4059 17.5942C9.88703 18.113 9.6276 18.3725 9.32485 18.558C9.05644 18.7225 8.7638 18.8437 8.4577 18.9172C8.11243 19.0001 7.74555 19.0001 7.01178 19.0001H6L3 21.0001L5 18.0001V16.9883C5 16.2545 5 15.8876 5.08289 15.5424C5.15638 15.2363 5.27759 14.9436 5.44208 14.6752C5.6276 14.3725 5.88703 14.113 6.40589 13.5942L10 10.0001",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEyeDropper;
